module.exports = __webpack_public_path__ + "60a895a3a66eb49814103fc8eeddcf8a.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/termine/RaumohneWande.jpg
// module id = 574
// module chunks = 0